<div class="frame" *ngIf="this.file" (click)="showPreview.next(true)">
  <div class="file-container">
    <div class="pdf" *ngIf="'pdf' === file.extension; else img">
      <iframe [src]="file.urlSafe" title="File pdf" width="14px" height="20px"> </iframe>
    </div>
    <ng-template #img>
      <img [ngSrc]="file.urlSafe" height="24" alt="uploaded_file" />
    </ng-template>
  </div>
  <span class="file-name">{{ this.file.fileData.name }}</span>
  <app-icon name="delete" color="#ff6200" class="mr-10 delete-icon" (click)="remove(index)"></app-icon>
  <div></div>
</div>
